import { getExperimentPropertiesForEventPayload } from './../lib/platform/getExperimentPropertiesForEventPayload';

//
// Segment analytics event tracking that includes experiment data.
//
// https://segment.com/docs/libraries/analytics.js/
//
export default function trackEvent (event, params={}, options={}, callback) {

    params = {
        url: window.location.href,
        ...getExperimentPropertiesForEventPayload(),
        ...params
    };

    if (__DEV__) {
        console.info('Track event: "%s": %o', event, params); // eslint-disable-line no-console
    }

    if (window.analytics) {
        window.analytics.track(event, params, options, callback);
    } else {
        if (typeof(callback) == 'function') {
            callback();
        }
    }
}



// WEBPACK FOOTER //
// ./~/@99designs/utils/platform/trackEvent.js